import { useEffect } from "react";
import { useLocation } from "wouter";
import { eventsForLocation, recordProductEvent } from "@/lib/first-party-analytics";

/** Sends allowlisted page and feature events after analytics consent. */
export function ProductAnalyticsListener() {
  const [location] = useLocation();
  useEffect(() => {
    for (const event of eventsForLocation(location)) {
      void recordProductEvent(event);
    }
  }, [location]);
  return null;
}
